import * as React from 'react';
import {Box} from '@mui/material';
import {required, TextInput} from 'react-admin';

interface LanguageConfig {
  defaultLanguage: string;
  supportedLanguages: string[];
}

const fallbackLanguageConfig: LanguageConfig = {
  defaultLanguage: 'sv',
  supportedLanguages: ['sv', 'en'],
};

const getLanguageConfigUrl = () => {
  const apiUrl = process.env.REACT_APP_API_URL ?? '';
  return `${apiUrl.replace(/\/admin\/?$/, '')}/languages`;
};

interface LocalizedTitleInputsProps {
  stacked?: boolean;
}

export const LocalizedTitleInputs = ({stacked = false}: LocalizedTitleInputsProps) => {
  const [languageConfig, setLanguageConfig] = React.useState<LanguageConfig>(fallbackLanguageConfig);

  React.useEffect(() => {
    const fetchLanguageConfig = async () => {
      try {
        const response = await fetch(getLanguageConfigUrl());
        const config = await response.json();
        setLanguageConfig(config);
      } catch (exception) {
        setLanguageConfig(fallbackLanguageConfig);
      }
    };

    fetchLanguageConfig();
  }, []);

  return (
    <Box display="flex" flexDirection={stacked ? 'column' : 'row'} gap={2} width="100%">
      {languageConfig.supportedLanguages.map(language => (
        <Box flex={stacked ? undefined : 1} width={stacked ? '50%' : undefined} key={language}>
          <TextInput
            source={`localizedStrings.title.${language}`}
            label={`Titel (${language})`}
            validate={language === languageConfig.defaultLanguage ? [required()] : undefined}
            fullWidth
          />
        </Box>
      ))}
    </Box>
  );
};
